export default __webpack_public_path__ + "static/conatel-46e841ce2e24e18a6db16bae7c68ca8c.webp";